import React, { createRef } from 'react';
import classnames from 'classnames';
import findIndex from 'lodash/findIndex';

import Swiper from 'react-id-swiper';

import 'react-id-swiper/src/styles/css/swiper.css';

import Logo from '../Logo';

import styles from './styles.scss';

const LINKS = [
  {
    'name': 'POLLS',
    'link': '//politico.com/2020-election/democratic-presidential-candidates/polls/',
  },
  {
    'name': 'ISSUES',
    'link': '//politico.com/2020-election/candidates-views-on-the-issues/',
  },
  {
    'name': 'ENDORSEMENTS',
    'link': '//politico.com/2020-election/democratic-presidential-candidates/endorsements/',
  },
  {
    'name': 'MONEY',
    'link': '//politico.com/2020-election/president/democratic-primary/candidates/fundraising-and-campaign-finance-tracker/',
  },
];

const getLinkIndex = name => {
  return findIndex(LINKS, l => l.name.toLowerCase() === name.toLowerCase());
};

class Navigation extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      swiper: null,
      overflowing: false,
      overflow: {
        left: false,
        right: false,
      },
    };

    this.linkTray = createRef();
  }

  onReachBegin = () => {
    this.setState({ overflow: {
      left: false,
      right: true,
    } });
  }

  onReachEnd = () => {
    this.setState({ overflow: {
      left: true,
      right: false,
    } });
  }

  onFromEdge = () => {
    this.setState({ overflow: {
      left: true,
      right: true,
    } });
  }

  initOverlay = () => {
    const { swiper } = this.state;
    const linkTray = this.linkTray.current;
    const overflowing = swiper.virtualSize > linkTray.offsetWidth;

    this.setState({ overflowing });
  }

  activate = () => {
    const { active } = this.props;

    const linkIndex = getLinkIndex(active);

    // Essentially call the resize handler manually
    const swiper = this.state.swiper;
    window.swiper = swiper;
    swiper.updateSize();
    swiper.updateSlides();

    let newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
    newTranslate = newTranslate === 0 ? 0 : newTranslate + 20;
    swiper.setTranslate(newTranslate);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();

    if (linkIndex === 0) {
      this.setState({ overflow: {
        left: false,
        right: true,
      } });
    } else if (linkIndex === LINKS.length - 1) {
      this.setState({ overflow: {
        left: true,
        right: false,
      } });
    }
  }

  getSwiper = swiper => {
    this.setState({ swiper }, () => {
      setTimeout(() => {
        this.activate();
        this.initOverlay();
      }, 1);
    });
    this.onResizeListener = window.addEventListener('resize', this.initOverlay);
  }

  componentWillUnmount() {
    if (this.onResizeListener) {
      window.removeEventListener(this.onResizeListener);
    }
  }

  render() {
    const { active, background, gradient, edge } = this.props;
    const { overflow, overflowing } = this.state;

    const startLinkIndex = this.props.active.toUpperCase();

    return (
      <div
        className={classnames('nav-header', styles.styles)}
        style={{
          backgroundColor: background,
        }}
      >
        <div className='inner-container'>
          <Logo />
          <div className='link-tray' ref={this.linkTray}>
            <Swiper
              freeMode
              mousewheel
              slidesPerView='auto'
              activeSlideKey={startLinkIndex}

              on={{
                reachBeginning: this.onReachBegin,
                reachEnd: this.onReachEnd,
                fromEdge: this.onFromEdge,
              }}
              getSwiper={this.getSwiper}>
              {
                LINKS.map(({ name, link }) => (
                  <div key={name} className={classnames('link-container', { active: active.toLowerCase() === name.toLowerCase() })}>
                    <a href={link}>{name}</a>
                  </div>
                ))
              }
            </Swiper>
            <div
              className={classnames('shadow-overlay', 'left', { active: overflowing && overflow.left })}
              style={{
                backgroundImage: `linear-gradient(
                  to left,
                  ${gradient},
                  ${edge}
                )`,
              }}
            />
            <div
              className={classnames('shadow-overlay', 'right', { active: overflowing && overflow.right })}
              style={{
                backgroundImage: `linear-gradient(
                  to right,
                  ${gradient},
                  ${edge}
                )`,
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

Navigation.defaultProps = {
  active: '',
  background: 'transparent',
  edge: '#f8f8f8',
  gradient: 'rgba(255, 255, 255, 0)',
};

export default Navigation;
